export const enum SearchCreateFormPhase {
  FORM = 'FORM',
  REVEAL = 'REVEAL',
}
